import { useBrandingStore } from "../../stores/Branding";

interface OfficeMapProps {
  width?: number;
  height?: number;
}

export default function OfficeMap(props: OfficeMapProps) {
  const branding = useBrandingStore((s) => s.branding);
  return (
    <iframe
      src={branding?.contact?.mapEmbed}
      width={props.width || "100%"}
      height={props.height || "100%"}
      style={{ border: 0, borderRadius: 25 }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  );
}
